import { Theme } from "../types/theme.js";

export const mobileBreakPoint = 960;
export const mobileBreakPointCSS = "960px";

const defaultTheme: Theme = {
  spacing: {
    xs: "10px",
    s: "20px",
    m: "30px",
    l: "50px",
    xl: "80px",
    xxl: "170px",
  },

  fontSizes: {
    tiny: ".75rem",
    small: "1rem",
    medium: "1.25rem",
    large: "1.5rem",
    larger: "1.875rem",
    largest: "3.125rem",
  },
  borderRadius: "10px",
};

export default defaultTheme;
